import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import './Redes.css';

function Redes() {
  usePageTitle('Contáctanos en Redes');

  const whatsappMessage = encodeURIComponent(
    'Hola, estoy interesado en tus servicios, me puedes dar más información'
  );
  const whatsappNumber = '525522632166';

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/procam360mx',
      icon: (
        <svg viewBox="0 0 320 512" width="1.5em" height="1.5em" fill="currentColor">
          <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/>
        </svg>
      ),
      color: 'var(--color-primary)',
      gradient: 'linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/procam360mx',
      icon: (
        <svg viewBox="0 0 448 512" width="1.5em" height="1.5em" fill="currentColor">
          <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
        </svg>
      ),
      color: 'var(--color-primary)',
      gradient: 'linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))',
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@procam360mx',
      icon: (
        <svg viewBox="0 0 448 512" width="1.5em" height="1.5em" fill="currentColor">
          <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/>
        </svg>
      ),
      color: 'var(--color-primary)',
      gradient: 'linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))',
    },
    {
      name: 'WhatsApp',
      url: `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`,
      icon: (
        <svg viewBox="0 0 448 512" width="1.5em" height="1.5em" fill="currentColor">
          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
        </svg>
      ),
      color: 'var(--color-primary)',
      gradient: 'linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))',
    },
    {
      name: 'Cotizar Ahora',
      url: 'https://crm.procam360.mx/forms/cotizar',
      icon: (
        <svg viewBox="0 0 512 512" width="1.5em" height="1.5em" fill="currentColor">
          <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-77.6c1.4-4.8 3.8-9.2 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"/>
        </svg>
      ),
      color: 'var(--color-primary)',
      gradient: 'linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))',
      isPrimary: true,
    },
  ];

  return (
    <div className="redes-page">
      <div className="redes-container">
        <div className="redes-header">
          <Link to="/">
            <img
              src="/logos/logo_color_transparente.png"
              alt="ProCam360"
              className="redes-logo"
            />
          </Link>
          <h1>Formas de contacto</h1>
          <p className="redes-subtitle">Tu opción en cabinas 360°</p>
          <p className="redes-description">
            Descubre los mejores momentos que hemos capturado en video 360°.
            Cada evento es único, cada recuerdo es especial.
          </p>
        </div>

        <div className="redes-links">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`redes-link ${link.isPrimary ? 'redes-link-primary' : ''}`}
              style={{
                '--link-gradient': link.gradient,
                '--link-color': link.color,
              }}
              aria-label={`Visitar ${link.name} de ProCam360`}
            >
              <div className="icon-wrapper">{link.icon}</div>
              <span>{link.name}</span>
              <i className="fas fa-arrow-right"></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Redes;
